import React from "react";
import Axios from 'axios';
import * as yup from "yup";
import {map, isEmpty} from "lodash";
import {message, Select} from "antd";
import Script from "react-load-script";
import moment from "moment-timezone";
import {PlusOutlined} from '@ant-design/icons';
import Loader from "../../../../../../Common/Component/Loader";
import AllState from "../../../../../../../Assets/data/stateList.json";
import cross_icon from "../../../../../../../Assets/images/cross_icon.svg";
import { aboutUsData } from "../../../../../../../Assets/data/aboutUsList";

const {Option} = Select;
const REGULAR_EXPRESSION_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class BasicDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      zipcodeCheck: false,
      zipcode: '',
      franchises: [],
      firstName: '',
      lastName: '',
      address: {address: '', city: '', state: '', zip_code: ''},
      phone_numbers: [],
      emails: [],
      authorizedUser: [],
      phone: '',
      phone_type: 'mobile',
      can_send_sms: false,
      email: '',
      isLocalValueChanged: false,
      loader: false,
      is_address_manually: false
    }
  }

  componentDidMount = () => {
    const { serviceOrderEnquiry, customerList } = this.props;

    // Set Service Address
    if (serviceOrderEnquiry && serviceOrderEnquiry?.enquiryList && 
      serviceOrderEnquiry?.enquiryList?.results?.length > 0) {
      this.setState({
        address: {
          address: serviceOrderEnquiry?.enquiryList?.results[0]?.service_address?.address,
          address_two: serviceOrderEnquiry?.enquiryList?.results[0]?.service_address?.address_two,
          city: serviceOrderEnquiry?.enquiryList?.results[0]?.service_address?.city,
          state: serviceOrderEnquiry?.enquiryList?.results[0]?.service_address?.state,
          zip_code: serviceOrderEnquiry?.enquiryList?.results[0]?.service_address?.zip_code
        }
      }, () => {
        this.checkZipcode(serviceOrderEnquiry?.enquiryList?.results[0]?.service_zipcode);
      })
    }

    // Set Basic Details
    if (customerList && customerList?.customer && Object.keys(customerList?.customer).length > 0) {
      this.setState({
        firstName: customerList?.customer?.first_name,
        lastName: customerList?.customer?.last_name,
        emails: customerList?.customer?.emailaddress_set,
        phone_numbers: customerList?.customer?.phone_numbers,
        hear_about_us: customerList?.customer?.hear_about_us
      }, () => {
      });
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const {zipCode} = this.state;

    // Check zipcode
    if (nextProps?.zipcodeCheck && Object.keys(nextProps?.zipcodeCheck?.data).length > 0
        && Object.keys(nextProps?.zipcodeCheck?.data.results).length > 0) {
      // && JSON.stringify(nextProps?.zipcodeCheck?.data) !== JSON.stringify(this.props?.zipcodeCheck?.data)) {
      
      this.setState({
        zipcodeCheck: true,
        franchises: nextProps?.zipcodeCheck?.data?.results,
        errors: {},
        loader: false
      });
    } else if (! nextProps?.zipcodeCheck?.data?.results?.length > 0 && zipCode === ''){
      this.setState({
        zipcodeCheck: false,
        franchises: [],
        errors: {},
        loader: false
      });
    }
  }

  // set address
  setAddress = (addressObject) => {
    const {address} = this.state;
    if (!isEmpty(addressObject)) {
      if (addressObject?.status === "OK") {
        let obj = {}, components = addressObject?.results?.[0];
        map(components?.address_components, (item) => {
          if (item?.types?.includes('administrative_area_level_2')) {
            obj = Object.assign(obj, { 'address': item.short_name })
          }
          if (item?.types?.includes('route')) {
            obj = Object.assign(obj, { 'route': item.short_name })
          }
          if (item?.types?.includes('street_number')) {
            obj = Object.assign(obj, { 'street_number': item.short_name })
          }
          if (item?.types?.includes('administrative_area_level_1')) {
            obj = Object.assign(obj, { 'state': item.short_name })
          }
          if (item?.types?.includes('locality')) {
            obj = Object.assign(obj, { 'city': item.long_name })
          }
          if (item?.types?.includes('postal_code')) {
            obj = Object.assign(obj, { 'zip_code': item.short_name })
          }
        });
        this.setState({address: {...address, ...obj}}, () => {
          if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
            message.error('Please enter valid address');
          }
          this.setState({isLocalValueChanged: true})
        });

      } else {
        message.error('Something went wrong while getting address')
      }
    }
  }

  // Google Map Place API
  handleScriptLoad = () => {
    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_address'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newAutoComplete.setFields(['address_components', 'formatted_address', 'geometry', 'icon', 'name']);

    // Fire Event when a suggested name is selected
    newAutoComplete.addListener('place_changed', this.handlePlaceSelect);

    this.setState({
      autocomplete: newAutoComplete,
    })
  };
  removeEmpty=(obj) =>{
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => (v !== null && v?.trim() !== "")));
  }

  // On start place change
  handlePlaceSelect = () => {
    const address= document?.getElementById('google_address')?.value;
    Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
      params: this.removeEmpty({
        latlng: undefined,
        address,
        key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
      })
    }).then((res) => {
      const addressObject = res?.data?.results[0];
      const address = addressObject.address_components;
      let obj = {};
      if (address) {
        map(addressObject?.address_components, (item) => {
          if (item?.types?.includes('administrative_area_level_2')) {
            obj = Object.assign(obj, { 'address': item.short_name })
          }
          if (item?.types?.includes('route')) {
            obj = Object.assign(obj, { 'route': item.long_name })
          }
          if (item?.types?.includes('street_number')) {
            obj = Object.assign(obj, { 'street_number': item.short_name })
          }
          if (item?.types?.includes('administrative_area_level_1')) {
            obj = Object.assign(obj, { 'state': item.short_name })
          }
          if (item?.types?.includes('locality')) {
            obj = Object.assign(obj, { 'city': item.long_name })
          }
          if (item?.types?.includes('postal_code')) {
            obj = Object.assign(obj, { 'zip_code': item.short_name })
          }
        });
        obj.address=`${obj?.street_number || ''} ${obj?.route || ''}`;
        this.setState({address: {...address, ...obj}}, () => {
          if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
            message.error('Please enter valid address');
          }
          this.setState({isLocalValueChanged: true})
        });
      }
    }).catch((err) => {
      console.log(err);
    })
  }

  // on service detail change
  onTextChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value }, () => this.setState({isLocalValueChanged: true}));
  }

  //on change
  onChange = (row, name) => {
    const {phone_numbers, emails, authorizedUser} = this.state;
    let data = name === 'phone' ? phone_numbers : name === 'email' ? emails : authorizedUser;
    data.splice(row, 1);
    if (name === 'phone' || name === 'email') {
      const idx = data?.findIndex(x => x.primary);
      if (idx <= -1 && !isEmpty(data)) data[0].primary = true;
    }
    this.setState({
      [name === 'phone' ? 'phone_numbers' : name === 'email' ? 'emails' : 'authorizedUser']: data
    }, () => this.setState({isLocalValueChanged: true}));
  };

  //on add
  onAdd = (name) => {
    const {phone_numbers = [], emails = [], authorizedUser = [], user_name, phone, can_send_sms, phone_type, email} = this.state;
    if (name === 'phone') {
      phone_numbers.push({phone: phone, can_send_sms, primary: phone_numbers?.length === 0, type: phone_type });
      this.setState({phone_numbers}, () => {this.setState({isLocalValueChanged: true, phone: '', phone_type: 'mobile', can_send_sms: false})});
    } else if (name === 'email') {
      emails.push({email, primary: emails?.length === 0});
      this.setState({emails}, () => {this.setState({isLocalValueChanged: true, email: ''})});
    } else {
      authorizedUser.push({user_name, created_at: moment().format('MM/DD/YYYY')});
      this.setState({authorizedUser}, () => {this.setState({isLocalValueChanged: true, user_name: ''})});
    }
  };

  // validate numeric input
  onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-')
  };

  // on primary phone number changed
  onPhonePrimaryChanged = (index) => {
    const {phone_numbers} = this.state;
    map(phone_numbers, (obj) => obj.primary = false)
    phone_numbers[index].primary = true
    this.setState({phone_numbers}, () => this.setState({isLocalValueChanged: true}))
  }
  
  // on primary phone number changed
  onEmailPrimaryChanged = (index) => {
    const {emails} = this.state;
    map(emails, (obj) => obj.primary = false)
    emails[index].primary = true
    this.setState({emails}, () => this.setState({isLocalValueChanged: true}))
  }

  // check for logged in user zipcode
  checkedLoggedInUserZipcode = (zipCode) => {
    let authUser = JSON.parse(localStorage.getItem('authUser'));

    if (!isEmpty(authUser) && authUser?.user?.zip_codes) {
      return authUser.user.zip_codes.includes(zipCode);
    }
    return false
  }

  // on zip code changed
  onZipcodeChange = (e) => {
    this.setState({zipcode: e.target.value, isLocalValueChanged: true}, () => 
    {
      const {zipcode} = this.state;

      if (zipcode.length === 5) {
        this.setState({loader: true});
        const checkedZipcode = this.checkedLoggedInUserZipcode(zipcode);

        if (checkedZipcode) {
          this.props.checkZipCode({
            addressable_zip_codes__contains: zipcode,
            close: false
          }); // check zip code)
        } else {
          this.setState({zipcodeCheck: false}, () => this.props.resetCheckZipcode())
        }
      } else {
        this.setState({zipcodeCheck: false}, () => this.props.resetCheckZipcode())
      }
    });
  };

  // get franchise for zipcode
  checkZipcode = (value) => {
    if (value && value !== this.state.zipcode) {
      this.setState({
        loader: true,
        zipcode: value
      });

      this.props.checkZipCode({
        addressable_zip_codes__contains: value,
        close: false
      }); // check zip code
    }
  }

  // format phone number
  formatPhoneNumber = (phone) => {
    if (!phone) return '';

    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  // on address change
  onAddressChange = (e) => {
    const {address} = this.state;
    Object.assign(address, {[e.target.name]: e.target.value})
    this.setState({address});
  };

  // store data in local storage
  storeInLocal = () => {
    const {
      phone_numbers,
      emails,
      firstName,
      lastName,
      address,
      zipcode,
      authorizedUser,
      zipcodeCheck,
      is_address_manually
    } = this.state;
    const google_address = this.refs['address'] ? this.refs['address'].value: '';
    // sessionStorage.setItem('basicDetail', JSON.stringify({ firstName, lastName, address, phone_numbers, emails, authorizedUser, zipcode, zipcodeCheck, is_address_manually, google_address }))

    this.props.setBasicDetails({
      firstName,
      lastName,
      address,
      phone_numbers,
      emails,
      authorizedUser,
      zipcode,
      zipcodeCheck,
      is_address_manually,
      google_address
    });
  }

  // validate required fields
  validate = () => {
    const {
      phone_numbers,
      emails,
      firstName,
      lastName,
      address,
      zipcodeCheck,
      zipcode} = this.state;

    const schema = yup.object().shape({
      zipcode: yup.string().required('Zipcode is required'),
      zipcodeCheck: yup.bool(),
      firstName: yup.string().required('First name is required'),
      lastName: yup.string().required('Last name is required'),
      address: yup.object().shape({
        address: yup.string().required('address is required.'),
        city: yup.string().required('city is required.'),
        state: yup.string().required('state is required.'),
        zip_code: yup.string().test('match', 'zip code is required.', (zip_code) => {
          if (zipcodeCheck) return zip_code //=== zipcode
          return true
        }),
      }),
      // phone_numbers: yup.array(yup.object({
      //   phone: yup.string().required('Phone is required')
      // })).required("Phone number is required"),
      emails: yup.array(yup.object({
        email: yup.string().required('Email is required')
      })).required("Email Address is required"),
    });

    const data = {
      zipcode,
      zipcodeCheck,
      firstName,
      lastName,
      address,
      phone_numbers,
      emails,
    };

    return schema.validate(data, { abortEarly: false }).then(() => {
      this.setState({isBasicDetail: true, errors: {}}, () => {
        this.storeInLocal();
      });
      return Promise.resolve('success')
    }).catch((error) => {
      let err_data = {};
      map(error?.inner, (item) => {err_data[item.path] = item.message})
      this.setState({errors: err_data, isBasicDetail: false});
      return Promise.reject('fail')
    });
  };

  // render all state
  renderAllState = () => {
    return AllState.AllState.map((item, i) => {
      return (<Option value={item.abbreviation} key={i}>{item.name}</Option>)
    })
  }

  // render phone numbers
  renderPhoneNumbers = () => {
    const {
      phone_numbers,
      phone,
      phone_type,
      can_send_sms,
      errors,
      zipcodeCheck
    } = this.state;

    return (
      <div>
        <h5 className=" mt-30">Phone Numbers</h5>
        <div className="inline-check-list gcheck">
          {
            map(phone_numbers, (item, index) => 
              <div className="fitem-check" key={`phoneNumber${index}`}>
                <input type="radio" className="fitem-ck-input" id={`checkboxPhone${index}`} name={`checkboxPhone${index}`} checked={item?.primary}
                  onChange={() => this.onPhonePrimaryChanged(index)} />
                <label htmlFor={`checkboxPhone${index}`} className="fitem-ck-txt black">{`+1 ${this.formatPhoneNumber(item?.phone)} ${item?.primary ? '(Primary)' : ''}`}</label>
                <a className="red float-right" href="/#" onClick={(e) => {e.preventDefault(); this.onChange(index, 'phone')}}><u>Remove</u></a>
              </div>)
          }
        </div>
        <div className="fitem fitem-rinner mt-10 flex">
          <input 
            name="phone"
            type="text"
            placeholder="Add New Phone Number"
            value={phone}
            maxLength={"10"}
            disabled={!zipcodeCheck}
            max={"10"} onChange={(e) => this.onNumericInputChange(e.target.value) && this.onTextChange(e)}
          />
          <Select
            onChange={(e) => this.onTextChange({target: {name: 'phone_type', value: e}}) }
            style={{marginLeft: "8px", marginRight: "8px"}}
            name="phone_type"
            value={phone_type}
            placeholder="Type">
            <Option value="home_phone">Home</Option>
            <Option value="mobile">Mobile</Option>
          </Select>
          <button className={`btn ${phone.length !== 10 ? 'disabled' : 'btn-warning'}`}
            disabled={phone.length !== 10} onClick={() => this.onAdd('phone')}><PlusOutlined /></button>
        </div>
        {phone_type === 'mobile' ? <div className="fitem-check">
          <input
            type="checkbox"
            className="fitem-ck-input"
            id={`can_send_sms`}
            onChange={(e) => this.onTextChange(e, 'bool')}
            checked={can_send_sms}
            name="can_send_sms" />
          <label htmlFor={`can_send_sms`} className="fitem-ck-txt">{`Send SMS updates about my service to this number.`}</label>
        </div> : ''}
        {errors?.[`phone_numbers`] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.[`phone_numbers`]}</label> : ''}
      </div>
    )
  }

  // render email addresses
  renderEmails = () => {
    const {emails, email, errors} = this.state;
    return (
      <div>
        <h5 className=" mt-30">Email Addresses</h5>
        <div className="inline-check-list gcheck">
          {map(emails, (item, index) => item?.email ? <div className="fitem-check" key={`email${index}`}>
            <input type="checkbox" className="fitem-ck-input" id={`checkboxEmail${index}`} name={`checkboxEmail${index}`} checked={item?.primary}
              onChange={() => this.onEmailPrimaryChanged(index)}/>
            <label htmlFor={`checkboxEmail${index}`} className="fitem-ck-txt black">{`${item?.email} ${item?.primary ? '(Primary)' : ''}`}</label>
            <a className="red float-right" href="/#" onClick={(e) => {e.preventDefault(); this.onChange(index, 'email')}}><u>Remove</u></a>
          </div> : ''
          )}
        </div>
        <div className="fitem fitem-rinner mt-10">
          <input name="email" type="text" placeholder="Add New Email Address" value={email}
            onChange={(e) => this.onTextChange(e)}/>
          <button className={`btn fitem-ricon ${!REGULAR_EXPRESSION_EMAIL.test(email) ? 'disabled' : 'btn-warning'}`}
            disabled={!REGULAR_EXPRESSION_EMAIL.test(email)} onClick={() => this.onAdd('email')}><PlusOutlined /></button>
        </div>
        {errors?.[`emails`] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.[`emails`]}</label> : ''}
      </div>
    )
  };

  // render authorized proposal
  renderAuthorizedUsers = () => {
    const {authorizedUser, user_name, zipcodeCheck} = this.state;
    return (
      <div>
        <h5 className=" mt-30">Authorized Users</h5>
        <div className="inline-check-list gcheck">
          {map(authorizedUser, (item, index) => <div className="fitem-check flex" key={`user${index}`}>
            <b className="d-block">{item?.user_name}</b>
            <div className="flex">
              <span className="mr-2">{`Added ${moment(item?.created_at)?.format('MM/DD/YYYY')}`}</span>
              <a className="red" href={'/#'} onClick={(e) => {e.preventDefault(); this.onChange(index, 'authorizedUser')}}><u>Remove</u></a>
            </div>
          </div>
          )}
        </div>
        <div className="fitem fitem-rinner mt-10">
          <input name="user_name" type="text" placeholder="Add New Authorized User" value={user_name} disabled={!zipcodeCheck}
            onChange={(e) => this.onTextChange(e)}/>
          <button className={`btn fitem-ricon ${!user_name ? 'disabled' : 'btn-warning'}`}
            disabled={!user_name} onClick={() => this.onAdd('authorizedUser')}><PlusOutlined /></button>
        </div>
      </div>
    );
  }

  // render Lead source
  renderLeadSource = () => {
    const {hear_about_us} = this.state;

    return (
      <div>
        <h5 className=" mt-30">How did you hear about us</h5>
        <div className="inline-check-list gcheck">
          <Select
            name="hear_about_us"
            value={hear_about_us}
            placeholder="Select the source"
            onChange={(e) => this.onTextChange({ target: { name: 'hear_about_us', value: e } })}
          >
            {aboutUsData?.map((item) => (
                <Option id={item.id} value={item.value} key={item.id}>
                  {item.name}
                </Option>
            ))}
          </Select>
        </div>
      </div>
    )
  };

  renderZipValidation = () => {
    const {
      zipcodeCheck,
      franchises,
      zipcode
    } = this.state;
    const franchiseName = franchises?.map((obj) => obj?.name) || [];

    if(zipcode && zipcodeCheck)
    {
      return <div className="greenbox mb-30">
        <b className="d-block">We cover this area.</b>
        <b className="d-block">{`This is under the ${franchiseName?.toString()} Franchise.`}</b>
      </div>;
    }
    else if(zipcode && !zipcodeCheck)
    {
      return <div className="dangerbox mb-30">
        <b className="d-block">We don’t currently have any franchises covering this area. Save their email to notify them if we move into this area. </b>
      </div>;
    }
    else 
      return null;
  }

  render() {
    const {
      zipcodeCheck,
      zipcode,
      firstName,
      lastName,
      address,
      errors,
      loader,
      is_address_manually
    } = this.state;
    
    let addressStr = address?.address ? `${address?.address}` : '';
    addressStr += address?.city ? `,${address?.city}` : '';
    addressStr += address?.state ? `, ${address?.state}` : '';
    addressStr += address?.zip_code ? `, ${address?.zip_code}` : '';

    if (this.refs['address']) {
      this.refs['address'].value = addressStr;
    }

    return (
      <div className="aleft">
        {loader && <Loader />}
        <h4>Do we service this area?</h4>
        <p>If you are here, this is for a new customer calling right now. First of all, take their zipcode for their service address to make sure we service this area.</p>
        <div className="form-group">
          <div className="fitem">
            <label>Service Zipcode</label>
            <input type="text" placeholder="Zipcode" name="zipcode" max={5} maxLength={5} value={zipcode || ''}
              onChange={(e) => this.onZipcodeChange(e)}/>
            {errors?.['zipcode'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['zipcode']}</label> : ''}
          </div>
          { this.renderZipValidation()}
        </div>
        <div className="form-group">
          <h4>Contact Information</h4>
          {zipcodeCheck && <div className="fitem half-fitem">
            <div className="fitem half-fitem">
              <label>First Name</label>
              <input type="text" placeholder="First Name" name="firstName" value={firstName} onChange={(e) => this.onTextChange(e)} />
              {errors['firstName'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors['firstName']}</label> : ''}
            </div>
            <div className="fitem half-fitem">
              <label>Last Name</label>
              <input type="text" placeholder="Last Name" name="lastName" value={lastName} onChange={(e) => this.onTextChange(e)} />
              {errors['lastName'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors['lastName']}</label> : ''}
            </div>

            {/* <input type="text" placeholder="Customer Name" name="customerName" value={customerName} onChange={(e) => this.onTextChange(e)}/>
            {errors['customerName'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors['customerName']}</label> : ''} */}
          </div>}
          {zipcodeCheck && <div className="google_search_place fitem">
            <label>Address (Service)</label>
            <Script
              url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
              onLoad={() => window.requestAnimationFrame(this.handleScriptLoad)}
            />

            <input
              autoComplete="off"
              type="text"
              ref="address"
              disabled={(!zipcodeCheck || is_address_manually)}
              className={'form-control mb-10'}
              placeholder={"Location"}
              name="google_address"
              id="google_address"
              onChange={(e) => {
                if (!e.target.value) {
                  this.setState({
                    address: { address: '', state: '', city: '', zip_code: '' }
                  })
                }
              }}
            />
            <b>or <a href="/" onClick={(e) => {
              e.preventDefault();
              this.setState({
                is_address_manually: true,
                address: {address: '', city: '', state: '', zip_code: ''},
              }, () => {
                if (this.refs['address']) {
                  this.refs['address'].value = '';
                } })
            }}><u>enter address manually</u></a></b>
          </div>}
          {
            is_address_manually &&
            <div className="manually_address">
              <a href="/#" onClick={(e) => {
                e.preventDefault();
                this.setState({
                  is_address_manually: false,
                  address: {address: '', city: '', state: '', zip_code: ''},
                })
              }}><img src={cross_icon} alt="" className="float-right mb-10" /></a>
              <br />

              <div className="form-group mb-20">
                <div className="fitem">
                  <input
                    type="text"
                    placeholder="Address"
                    name="address"
                    value={address?.address}
                    onChange={(e) => this.onAddressChange(e)}
                  />
                </div>
                <div className="half-fitem fitem">
                  <div className="half-fitem fitem">
                    <input
                      type="text"
                      placeholder="City"
                      name="city"
                      value={address?.city}
                      onChange={(e) => this.onAddressChange(e)}
                    />
                  </div>
                  <div className="half-fitem fitem">
                    <Select
                      showArrow={true}
                      name="state"
                      placeholder="State"
                      onChange={(value) => this.onAddressChange({ target: { name: 'state', value: value } })}
                      value={address?.state || undefined}
                      virtual={false}
                    >
                      {this.renderAllState()}
                    </Select>
                  </div>
                  <div className="half-fitem fitem">
                    <input
                      type="text"
                      className='form--control'
                      placeholder="ZIP Code"
                      name="zip_code"
                      maxLength={5}
                      minLength={5}
                      onChange={(e) => this.onNumericInputChange(e.target.value) && this.onAddressChange(e)}
                      value={address?.zip_code || ''}
                    />
                  </div>
                </div>
              </div>
            </div>
          }
          {(errors?.['address.address'] || errors?.['address.city'] || errors?.['address.state'] || errors?.['address.zip_code'])
            ? <label className="new_err_msg"><i className="las la-info-circle"/>{'Please enter valid address'}</label> : ''}
        </div>
        {zipcodeCheck ? this.renderPhoneNumbers() : null}
        {this.renderEmails()}
        {zipcodeCheck ? this.renderAuthorizedUsers() : null}
        {zipcodeCheck ? this.renderLeadSource() : null}
      </div>
    )
  }
}

export default BasicDetail;